import { t } from "@lingui/macro";
import CONSTANTS from 'utils/constants'

const {
  ERROR_CODES: {
    BAD_CREDENTIALS, MAX_UNSUCCESSFUL_ATTEMPTS
  }
} = CONSTANTS;

export const getLoginErrorMessage = (code: string): string => {
  let errorMessage = t`Something went wrong, please try again later.`;

  if (code === BAD_CREDENTIALS) {
    errorMessage = t`Some of the data entered are incorrect. Try again.`;
  } else if (code === MAX_UNSUCCESSFUL_ATTEMPTS) {
    errorMessage = t`Account locked. Max unsuccessfull login attempts reached`;
  }
  return errorMessage;
}